import { ComplianceCalendarType } from "./complianceCalendarType";

export const initialState:ComplianceCalendarType={
    fetching: false,
    message:null,
    error: null,
    success: null,
    statusCode:null,
    complianceCalendarList:[],
}